import { Component, OnInit } from "@angular/core";

@Component({
    selector: "app-homefour-what-we-do",
    templateUrl: "./homefour-what-we-do.component.html",
    styleUrls: ["./homefour-what-we-do.component.scss"],
})
export class HomefourWhatWeDoComponent implements OnInit {
    constructor() {}

    ngOnInit(): void {}

    sectionTitle: sectionTitleContent[] = [
        {
            title: "Upstream Data Foundation ",
            subTitle: "A Single Platform",
            paragraphText:
                "Whether structured or semi-structured data comes from first, second, or third party sources, all data can be housed and analyzed on a single platform - UDF.",
        },
    ];
    singleWhatWeDoBox: whatWeDoContent[] = [
        {
            icon: "flaticon-segmentation",
            iconImage:
                "assets/img/what-we-do/map-location-removebg-preview.png",
            title: "Research",
            paragraphText:
                "Provides tools for performing complex data engineering and analytics in one single platform.",
            linkText1: "Market Research",
            link1: "services-details",
            linkText2: "Investment Research",
            link2: "services-details",
            linkText3: "Read More",
            link3: "services-details",
        },
        {
            icon: "flaticon-analytics",
            iconImage: "assets/img/what-we-do/clock-UDF-removebg-preview.png",
            title: "Analytics",
            paragraphText:
                "Cuts costs, saves time, and delivers economies of scale because the wheel isn’t reinvented for each use case.",
            linkText1: "Data Analytics",
            link1: "services-details",
            linkText2: "Business Intelligence",
            link2: "services-details",
            linkText3: "Read More",
            link3: "services-details",
        },
        {
            icon: "flaticon-settings",
            iconImage: "assets/img/what-we-do/puzzle-removebg-preview.png",
            title: "Technology",
            paragraphText:
                "Breaks down silos. People no longer work with their data in isolation because of the visibility of the data users and increased collaboration.",
            linkText1: "Intelligence Automation",
            link1: "services-details",
            linkText2: "Quality Engineering",
            link2: "services-details",
            linkText3: "Read More",
            link3: "services-details",
        },
    ];
}
class sectionTitleContent {
    title: string;
    subTitle: string;
    paragraphText: string;
}
class whatWeDoContent {
    icon: string;
    iconImage: string;
    title: string;
    paragraphText: string;
    linkText1: string;
    link1: string;
    linkText2: string;
    link2: string;
    linkText3: string;
    link3: string;
}
